import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Facebook, Instagram, Music2 } from "lucide-react";

const WHATSAPP_NUMBER = "526673093018";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B1220] text-white">
      <div className="w-full px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <img
                src="/logos/image.svg"
                alt="Tulocalmx"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">
                <span className="text-[#0056D2]">TULOCAL</span>
                <span className="text-[#F97316]">MX</span>
              </span>
            </div>

            <p className="text-sm text-gray-400">
              Plataforma de locales comerciales.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-gray-400">Empresa</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/quienes-somos" className="transition hover:text-white">
                  Lo que nos mueve
                </Link>
              </li>
              <li>
                <Link to="/como-te-ayudamos" className="transition hover:text-white">
                  Cómo te ayudamos
                </Link>
              </li>
              <li>
                <Link to="/con-quienes-colaboramos" className="transition hover:text-white">
                  Con quien colaboramos
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="transition hover:text-white">
                  Privacidad
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-gray-400">Contacto</h4>

            <div className="space-y-3 text-sm text-gray-300">
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Phone className="h-4 w-4" />
                +52 667 309 3018
              </a>

              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=ernesto@tulocalmx.mx"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Mail className="h-4 w-4" />
                contacto
              </a>

              <a
                href="https://maps.google.com/?q=Sinaloa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <MapPin className="h-4 w-4" />
                Culiacán, Sinaloa, México
              </a>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-gray-400">Redes sociales</h4>
            <div className="space-y-3 text-sm text-gray-300">
              <a
                href="https://www.tiktok.com/@tulocalmx"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Music2 className="h-4 w-4" />
                TikTok @tulocalmx
              </a>

              <a
                href="https://www.instagram.com/tulocalmx"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Instagram className="h-4 w-4" />
                Instagram @tulocalmx
              </a>

              <a
                href="https://www.facebook.com/profile.php?id=61563699170698"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 transition hover:text-white"
              >
                <Facebook className="h-4 w-4" />
                Facebook @tulocalmx
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full border-t border-white/10 px-4 py-6 text-center text-sm text-gray-400">
        © {currentYear} <span className="text-[#0056D2]">TULOCAL</span>
        <span className="text-[#F97316]">MX</span>
      </div>
    </footer>
  );
};

export default Footer;
